import api from '@/plugins/apiService'

import { storeActions, storeGetters, storeMutations } from '@/store/storeConstants'

const { FETCH_CUSTOMER_SUBSCRIPTION } = storeActions

const { GET_CUSTOMER_SUBSCRIPTION } = storeGetters
const { SET_CUSTOMER_SUBSCRIPTION } = storeMutations

export default {
  namespaced: true,
  state: {
    purchasePayload: JSON.parse(localStorage.getItem('purchasePlanDetails')) || [],
    customerPayload: [],
    subscriptionMode: [],
    nextRenewalDate: [],
    planConsumption: [],
    customerSubscription: {},
    isBuyManufacturingModule: JSON.parse(localStorage.getItem('isBuyManufacturingModule')) || false,
  },

  getters: {
    GET_PURCHASE_PAYLOAD: state => state.purchasePayload,
    GET_CUSTOMER_PAYLOAD: state => state.customerPayload,
    GET_SUBSCRIPTION_MODE: state => state.subscriptionMode,
    GET_NEXT_RENEWAL_DATE: state => state.nextRenewalDate,
    GET_PLAN_CONSUMPTION: state => state.planConsumption,
    GET_IS_BUY_MANUFACTURING_MODULE: state => state.isBuyManufacturingModule,
    [GET_CUSTOMER_SUBSCRIPTION]: state => {
      return state.customerSubscription
    },
  },

  mutations: {
    SET_PURCHASE_PAYLOAD: (state, payload) => {
      state.purchasePayload = payload
      localStorage.setItem('purchasePlanDetails', JSON.stringify(payload))
    },
    SET_CUSTOMER_PAYLOAD: (state, payload) => {
      state.customerPayload = payload
    },
    SET_SUBSCRIPTION_MODE: (state, payload) => {
      state.subscriptionMode = payload
    },
    SET_NEXT_RENEWAL_DATE: (state, payload) => {
      state.nextRenewalDate = payload
    },
    SET_PLAN_CONSUMPTION: (state, payload) => {
      state.planConsumption = payload
    },
    SET_IS_BUY_MANUFACTURING_MODULE: (state, payload) => {
      state.isBuyManufacturingModule = payload
      localStorage.setItem('isBuyManufacturingModule', JSON.stringify(payload))
    },
    SET_CUSTOMER_SUBSCRIPTION: (state, payload) => {
      state.customerSubscription = payload
    },
  },

  actions: {
    [FETCH_CUSTOMER_SUBSCRIPTION]: ({ commit }) => {
      api.findAll('payment/get-customer-subscription').then(({ data }) => {
        if (data.success) {
          commit(SET_CUSTOMER_SUBSCRIPTION, data.data)
        }
      })
    },

    async LIST_ALL_PLANS({ commit }) {
      try {
        const { data } = await api.findAll('payment/list-all-plans')
        // if (data.success) {
        return data.data
        // }
      } catch (error) {
        console.error('Error fetching Plans:', error)
      }
    },

    async GET_CUSTOMER_INVOICES({ commit }) {
      try {
        const { data } = await api.findAll(`payment/get-customer-invoices`)
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error fetching cutomer subscription:', error)
      }
    },

    async GET_TENANT_USER_DETAILS({ commit }) {
      try {
        const { data } = await api.findAll(`security/get-tenant-user-details`)
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error fetching cutomer subscription:', error)
      }
    },

    async PURCHASE_PLAN({ commit }, payload) {
      try {
        const { data } = await api.save('payment/purchase-plan', payload)
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error fetching cutomer subscription:', error)
      }
    },

    async CHANGE_PLAN({ commit }, payload) {
      try {
        const { data } = await api.save('payment/change-plan', payload)
        return data
      } catch (error) {
        console.error('Error fetching cutomer subscription:', error)
      }
    },

    async BUY_MANUFACTURING_MODULE({ commit }) {
      try {
        const { data } = await api.save('payment/buy-manufacturing-module')
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error fetching cutomer subscription:', error)
      }
    },

    async GET_ALL_INVOICES({ commit }, payload) {
      try {
        const { data } = await api.findAll(
          `ac-api/customer-licensing/get-tenant-invoices/${payload.tenant_id}`,
        )
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error fetching cutomer subscription:', error)
      }
    },

    async GET_ADMIN_CUSTOMER_SUBSCRIPTION({ commit }, payload) {
      return await api.findAll(
        `ac-api/customer-licensing/get-tenant-subscription/${payload.tenant_id}`,
      )
    },

    async UPDATE_CUSTOMER_SUBSCRIPTION_MODE({ commit }, payload) {
      try {
        const { data } = await api.update(
          `ac-api/customer-licensing/update-customer-subscription-mode/${payload.tenant_id}`,
        )
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error fetching cutomer subscription:', error)
      }
    },

    UPDATE_SUBCRIPTION({ commit }, payload) {
      // try {
      return api.update(`payment/update-subscription`, payload)
      // if (data.success) {
      //   return data
      // }
      // return data
      // } catch (error) {
      //   return error
      //   // console.error('Error fetching cutomer subscription:', error)
      // }
    },

    async EXTEND_TRIAL({ commit }, payload) {
      try {
        const { data } = await api.update('ac-api/customer-licensing/extend-trial', payload)
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error fetching cutomer subscription:', error)
      }
    },

    async CANCEL_PLAN({ commit }, payload) {
      try {
        const { data } = await api.delete(`payment/cancel-plan?subscription_id=${payload}`)
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error fetching cutomer subscription:', error)
      }
    },

    async ADD_ON_PLAN({ commit }, payload) {
      try {
        const { data } = await api.delete(`payment/cancel-addon-plan?subscription_id=${payload}`)
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error fetching cutomer subscription:', error)
      }
    },
  },
}
